import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ChangeEvent, FC, useRef } from "react";

import { Button, SpacingToken, Text, Textarea } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  value: string;
  onChange: (value: string) => void;
  testId?: string;
}

export const MessageField: FC<IProps> = ({ value, onChange, testId }) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const onAddVariable = (template: string): void => {
    onChange(value + template);
    textareaRef.current?.focus();
  };

  const onMessageChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    onChange(event.target.value);
  };

  return (
    <Flex column gap={withVar(SpacingToken.Spacing4)}>
      <Textarea
        placeholder="Enter message..."
        value={value}
        ref={textareaRef}
        css={textAreaStyles}
        onChange={onMessageChange}
        data-testid={testId}
      />
      <VariablesContainer>
        <Text>Add variables:</Text>
        {variables.map(param => (
          <Button kind="link" onClick={() => onAddVariable(param.template)} key={param.name}>
            {param.name}
          </Button>
        ))}
      </VariablesContainer>
    </Flex>
  );
};

const variables = [
  {
    template: "{{ticket.requesterName}}",
    name: "Ticket Requester Name",
  },
  {
    template: "{{ticket.shortID}}",
    name: "Ticket Short ID",
  },
  {
    template: "{{ticket.agentName}}",
    name: "Ticket Agent Name",
  },
] as const;

const textAreaStyles = css`
  width: 100%;
  max-width: 640px;
  textarea {
    resize: none;
    width: 100%;
    max-width: 640px;
    box-sizing: border-box;
    min-height: 100px;
  }
`;

const VariablesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${withVar(SpacingToken.Spacing1)} ${withVar(SpacingToken.Spacing3)};
`;
